import { Injectable } from '@angular/core';
import {HttpClientService} from "./http-client.service";
import {AppConfigService} from "./app-config.service";
import {Headers} from '@angular/http';

@Injectable()
export class ManageUserService {

  private apiUrl = AppConfigService.settings.apiUrl + 'users/';

  constructor(private http: HttpClientService) {
  }

  getData(id: string): Promise<any[]> {
    return this.http.get(this.apiUrl + 'get?id=' + id)
      .toPromise()
      .then(response => response.json() as any[])
      .catch(this.handleError);
  }

  deleteItem(id: number): Promise<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    return this.http.post(this.apiUrl + 'delete', JSON.stringify({id: id}), headers)
      .toPromise()
      .then(response => response.json() as any)
      .catch(this.handleError);
  }

  editData(data: any): Promise<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    return this.http.post(this.apiUrl + 'edit', JSON.stringify(data), headers)
      .toPromise()
      .then(response => response.json() as any)
      .catch(this.handleError);
  }

  resetPassword(data: any): Promise<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    return this.http.post(this.apiUrl + 'changepwd', JSON.stringify(data), headers)
      .toPromise()
      .then(response => response.json() as any)
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/manage-user.service.ts